import React from "react";
import "../styles/priceList.css";

export default function PriceList() {
  return (
    <section id="pricing" className="price-section pb-4">
      <div className="container">
        <h2 className="price-title">Bikázás árlista – Budapest és környéke</h2>
        <div className="double-divider my-4"></div>

        <div className="price-table-wrapper">
          <table className="price-table">
            <thead>
              <tr>
                <th>Időszak</th>
                <th>Alapdíj</th>
                <th>Megjegyzés</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Reggel 8:00 – 17:00</td>
                <td>15 000 Ft</td>
                <td>Alapdíj Budapest területén belül</td>
              </tr>
              <tr>
                <td>Este 17:00 – 21:00</td>
                <td>18 000 Ft</td>
                <td>Gyors kiszállás forgalmas időszakban</td>
              </tr>
              <tr>
                <td>Éjszaka 21:00 – 8:00</td>
                <td>Egyedi díj</td>
                <td>Telefonos egyeztetés alapján</td>
              </tr>
              <tr>
                <td>Távolság alapú felár</td>
                <td>+300 Ft / km</td>
                <td>
                  Budapesttől távolabbi vagy nehezen megközelíthető helyszínek
                  esetén
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="price-notes">
          <h5>💡 Fontos tudnivalók:</h5>
          <ul>
            <li>Az árak átlagos budapesti kiszállásra érvényesek.</li>
            <li>
              Ha a helyszín forgalmi vagy távolsági okból 30 percnél hosszabb
              kiszállást igényel, extra kiszállási díjat számolhatunk fel.
            </li>
            <li>
              Az extra díjról minden esetben előzetesen tájékoztatjuk az
              ügyfelet telefonon.
            </li>
            <li>
              Minden személyautó, kisteherautó és furgon bikázása vállalható.
            </li>
            <li>Bankkártyás és készpénzes fizetés is elérhető.</li>
            <li>
              Professzionális indítóeszközökkel dolgozunk – gyorsan és
              biztonságosan.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
